import { AbstractControl } from '@angular/forms';

export const PhoneValidator = (control: AbstractControl) => {
    if (control.value === null || control.value === '') {
        return null;
    }

    if (!control.value.toString().match(/^(9)[0-9]{8}$/)) {
        return { phoneInvalid: true };
    }

    return null;
};
